import { httpClient } from '../http-client';
import type { Departamento, Provincia, Distrito } from './types';

export const ubigeoService = {
  async getDepartamentos(): Promise<Departamento[]> {
    try {
      const response = await httpClient.get<Departamento[]>('/ubigeo/departamentos');
      return Array.isArray(response.data) ? response.data : [];
    } catch {
      return [];
    }
  },

  async getProvincias(codigoDepartamento: string): Promise<Provincia[]> {
    try {
      const response = await httpClient.get<Provincia[]>(
        '/ubigeo/provincias',
        { codigoDepartamento }
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch {
      return [];
    }
  },

  async getDistritos(
    codigoDepartamento: string,
    codigoProvincia: string
  ): Promise<Distrito[]> {
    try {
      const response = await httpClient.get<Distrito[]>(
        '/ubigeo/distritos',
        { codigoDepartamento, codigoProvincia }
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch {
      return [];
    }
  }
};
